import WebGLObject from './WebGLObject';
import TexturesController from './TexturesController';
import { BASIC_MATERIAL, PLANE_GEOMETRY } from '../../../3D/constants';
import { FrontSide, MeshBasicMaterial, ShaderMaterial, Vector2 } from 'three';
import CanvasColorTexture from './CanvasColorTexture';
import { RESPONSIVE_IMAGE_FRAGMENT, RESPONSIVE_IMAGE_VERTEX } from './shaders/responsive-image';

export default class Plane extends WebGLObject {
    color;

    constructor(opts = {}) {
        super(opts);

        if (!this.geometry) {
            this.geometry = PLANE_GEOMETRY;
        }

        if (!this.material) {
            this.setupMaterial();
        }

        this.init();
    }

    init() {
        super.init();
        this.resize();
    }

    setupMaterial() {
        this.color = this.dom.dataset.bg;
        this.material = new MeshBasicMaterial({ color: this.color, side: FrontSide });
    }

    update() {
        super.update();

        const { x, y, width, height } = this.dom.getBoundingClientRect();
        const position = this.domPositionTo3D(x, y);
        this.pos.x = position.x + width * .5;
        this.pos.y = position.y - height * .5;
        this.pos.z = parseInt(this.dom.dataset.layer);
    }

    resize() {
        const { x, y, width, height } = this.dom.getBoundingClientRect();
        const position = this.domPositionTo3D(x, y);

        this.position.x = this.pos.x = position.x + width * .5;
        this.position.y = this.pos.y = position.y - height * .5;
        this.pos.z = parseInt(this.dom.dataset.layer);

        super.resize(width, height);
    }
}
